import { usePersonalDetailsQuery } from './hooks';
import { PersonalDataForm } from './personal-data-form';
import { useParams } from 'react-router-dom';

export const PersonalDataFormWrapper = () => {
  const { userUid } = useParams();
  const employeeUid = userUid;

  const { data: personalDetails, isLoading, error } = usePersonalDetailsQuery({ uid: employeeUid ?? '' });

  if (!isLoading && !error && personalDetails) {
    return <PersonalDataForm uid={employeeUid ?? ''} isEmployeeLoading={isLoading} personalDetails={personalDetails} />;
  }

  return null;
};
